module.exports = __webpack_public_path__ + "static/media/image_16.fa18f8ef.jpg";